import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginTop: 80,
    paddingLeft: 25,
    paddingRight: 25,
  },

  contentTitle: {
    flexDirection: "row",
    marginTop: 25,
  },

  title: {
    fontSize: 18,
    color: "#000000",
    fontWeight: "bold",
    marginLeft: 15,
  },

  list: {
    marginTop: 20,
  },

  itemList: {
    cursor: "pointer",
  },

  contentItemList: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  textItemList: {
    fontSize: 15,
    color: "#2C2C2E",
    marginTop: 3,
  },

  hrLine: {
    height: 0.5,
    width: "100%",
    position: "relative",
    borderWidth: 0.8,
    marginTop: 10,
    marginBottom: 10,
    borderColor: "rgba(44, 44, 46, 0.5)",
  },

  icones: {
    width: 24,
    height: 24,
    tintColor: "#077A97",
  },

  buttonContainer: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 24,
    width: 246,
    height: 48,
    borderRadius: 4,
    backgroundColor: "#077A97",
    padding: 10,
    borderRadius: 5,
    alignItems: "center",
    justifyContent: "center",
  },

  buttonText: {
    color: "#FFFFFF",
    fontWeight: 500,
  },
});

export default styles;
